export enum FileExtension {
  jpg = 'jpg',
  gif = 'gif',
  bmp = 'bmp',
  png = 'png',
  mp4 = 'mp4',
  mov = 'mov',
  webm = 'webm',
}
